"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.loadUserApps = loadUserApps;
exports.pullUserApps = pullUserApps;
exports.deleteUserApp = deleteUserApp;
exports.watchLoadUserApps = watchLoadUserApps;
exports.watchPullUserApps = watchPullUserApps;
exports.watchDeletUserApp = watchDeletUserApp;
exports["default"] = exports.appsSagas = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _effects = require("redux-saga/effects");

var _utils = require("../../../utils");

var _actions = _interopRequireDefault(require("./actions"));

var _marked = _regenerator["default"].mark(loadUserApps),
    _marked2 = _regenerator["default"].mark(pullUserApps),
    _marked3 = _regenerator["default"].mark(deleteUserApp),
    _marked4 = _regenerator["default"].mark(watchLoadUserApps),
    _marked5 = _regenerator["default"].mark(watchPullUserApps),
    _marked6 = _regenerator["default"].mark(watchDeletUserApp);

function loadUserApps(api, action) {
  var _yield$api$getUserApp, data;

  return _regenerator["default"].wrap(function loadUserApps$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _context.prev = 0;
          _context.next = 3;
          return api.getUserApps({
            userId: action.payload.userId
          }).then(function (p) {
            return p.request;
          });

        case 3:
          _yield$api$getUserApp = _context.sent;
          data = _yield$api$getUserApp.data;
          _context.next = 7;
          return (0, _effects.put)(_actions["default"].loadUserAppsSuccess(data));

        case 7:
          _context.next = 13;
          break;

        case 9:
          _context.prev = 9;
          _context.t0 = _context["catch"](0);
          _context.next = 13;
          return (0, _effects.put)(_actions["default"].loadUserAppsError(_context.t0));

        case 13:
        case "end":
          return _context.stop();
      }
    }
  }, _marked, null, [[0, 9]]);
}

function pullUserApps(api, action) {
  var _action$payload, userId, appName, startAt;

  return _regenerator["default"].wrap(function pullUserApps$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          _context2.prev = 0;
          _action$payload = action.payload, userId = _action$payload.userId, appName = _action$payload.appName, startAt = _action$payload.startAt;
          _context2.next = 4;
          return api.pullAppsByUserId({
            userId: userId,
            appName: appName,
            startAt: startAt
          }).then(function (p) {
            return p.request;
          });

        case 4:
          _context2.next = 6;
          return (0, _effects.put)(_actions["default"].pullUserAppsSuccess());

        case 6:
          _context2.next = 12;
          break;

        case 8:
          _context2.prev = 8;
          _context2.t0 = _context2["catch"](0);
          _context2.next = 12;
          return (0, _effects.put)(_actions["default"].pullUserAppsError(_context2.t0));

        case 12:
        case "end":
          return _context2.stop();
      }
    }
  }, _marked2, null, [[0, 8]]);
}

function deleteUserApp(api, action) {
  var _action$payload2, userId, appName;

  return _regenerator["default"].wrap(function deleteUserApp$(_context3) {
    while (1) {
      switch (_context3.prev = _context3.next) {
        case 0:
          _context3.prev = 0;
          _action$payload2 = action.payload, userId = _action$payload2.userId, appName = _action$payload2.appName;
          _context3.next = 4;
          return api.deleteUserApp({
            userId: userId,
            appName: appName
          }).then(function (p) {
            return p.request;
          });

        case 4:
          _context3.next = 6;
          return (0, _effects.put)(_actions["default"].deleteUserAppSuccess(appName));

        case 6:
          _context3.next = 12;
          break;

        case 8:
          _context3.prev = 8;
          _context3.t0 = _context3["catch"](0);
          _context3.next = 12;
          return (0, _effects.put)(_actions["default"].deleteUserAppError(_context3.t0));

        case 12:
        case "end":
          return _context3.stop();
      }
    }
  }, _marked3, null, [[0, 8]]);
}

function watchLoadUserApps(api) {
  return _regenerator["default"].wrap(function watchLoadUserApps$(_context4) {
    while (1) {
      switch (_context4.prev = _context4.next) {
        case 0:
          _context4.next = 2;
          return (0, _effects.takeLatest)((0, _utils.getType)(_actions["default"].loadUserApps), loadUserApps, api);

        case 2:
        case "end":
          return _context4.stop();
      }
    }
  }, _marked4);
}

function watchPullUserApps(api) {
  return _regenerator["default"].wrap(function watchPullUserApps$(_context5) {
    while (1) {
      switch (_context5.prev = _context5.next) {
        case 0:
          _context5.next = 2;
          return (0, _effects.takeLatest)((0, _utils.getType)(_actions["default"].pullUserApps), pullUserApps, api);

        case 2:
        case "end":
          return _context5.stop();
      }
    }
  }, _marked5);
}

function watchDeletUserApp(api) {
  return _regenerator["default"].wrap(function watchDeletUserApp$(_context6) {
    while (1) {
      switch (_context6.prev = _context6.next) {
        case 0:
          _context6.next = 2;
          return (0, _effects.takeLatest)((0, _utils.getType)(_actions["default"].deleteUserApp), deleteUserApp, api);

        case 2:
        case "end":
          return _context6.stop();
      }
    }
  }, _marked6);
}

var appsSagas = function appsSagas(api) {
  return [(0, _effects.fork)(watchLoadUserApps, api), (0, _effects.fork)(watchPullUserApps, api), (0, _effects.fork)(watchDeletUserApp, api)];
};

exports.appsSagas = appsSagas;
var _default = appsSagas;
exports["default"] = _default;
//# sourceMappingURL=sagas.js.map